import React from 'react';

function FacebookTab({ project, categoryTab }) {
    let content;

  switch (categoryTab) {
    case 'leads':
      content = (
        <div>
          <h3 className="text-lg font-semibold mb-2">
            Facebook - {project} - Leads
          </h3>
          <p className="text-gray-700 mb-2">
            Content for Facebook Leads on Project: {project}
          </p>
          {/* Add facebook Leads specific content here */}
        </div>
      );
      break;
    case 'marketing':
      content = (
        <div>
          <h3 className="text-lg font-semibold mb-2">
            Facebook - {project} - Marketing
          </h3>
          <p className="text-gray-700 mb-2">
            Content for Facebook Marketing on Project: {project}
          </p>
          {/* Add facebook Marketing specific content here */}
        </div>
      );
    case 'birthdays':
      content = (
        <div>
          <h3 className="text-lg font-semibold mb-2">
            Facebook - {project} - Birthdays and Festivals
          </h3>
          <p className="text-gray-700 mb-2">
            Content for Facebook Birthdays on Project: {project}
          </p>
          {/* Add facebook Bithday Content here */}
        </div>
      );
      break;
     case 'postVisit':
      content = (
        <div>
          <h3 className="text-lg font-semibold mb-2">
            Facebook - {project} - Post Visit
          </h3>
          <p className="text-gray-700 mb-2">
            Content for Facebook Post Visit on Project: {project}
          </p>
          {/* Add facebook Post Visit Content here */}
        </div>
      );
      break;
    default:
      content = (
        <div>
          <p>No content defined for Facebook for this category tab.</p>
        </div>
      );
  }

  return (
    <div>
      {content}
    </div>
  );
}

export default FacebookTab;